// C6: English slug → Spanish slug, permanently. Kept as a component (not a
// bare <Navigate>) so search params (?c=, ?tab=) and :id segments survive the
// hop — a redirect that drops the deep link is a broken link with extra steps.

import { Navigate, useLocation, useParams } from 'react-router-dom'

/**
 * Permanent route alias (old English slug → Spanish slug) that keeps the deep
 * link intact: search params, hash and — with `withId` — the :id segment
 * survive the replace-navigation.
 */
export function LegacyRedirect({
  to,
  withId = false,
}: {
  to: string
  withId?: boolean
}): JSX.Element {
  const { id } = useParams()
  const { search, hash } = useLocation()
  const path = withId && id ? `${to}/${id}` : to
  return <Navigate to={`${path}${search}${hash}`} replace />
}
